import { ACTIVATE_CLICK_ON_SEARCH_BAR } from "./clickOnSearchBarReducer"

export const activateClickOnSearchBar = (date) => ({
    type: ACTIVATE_CLICK_ON_SEARCH_BAR,
    payload: date
})